import { render } from "./Navigator.vue?vue&type=template&id=7c5fe3bf"
import script from "./Navigator.vue?vue&type=script&lang=js"
export * from "./Navigator.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__